module.exports = __webpack_public_path__ + "img/sticker_3.035240db.svg";